var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEstrella34X34(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4307 2.8335C17.8095 2.8335 18.1597 3.03522 18.3498 3.36294L22.7887 11.0167L31.4378 12.873C31.8085 12.9525 32.1087 13.2236 32.2256 13.5843C32.3425 13.945 32.2583 14.3407 32.0047 14.6225L26.0871 21.199L27.0016 29.9944C27.0408 30.3714 26.8763 30.7407 26.5698 30.9636C26.2634 31.1865 25.8614 31.2293 25.5148 31.0759L17.4307 27.4979L9.34653 31.0759C8.99999 31.2293 8.59799 31.1865 8.29152 30.9636C7.98505 30.7407 7.82051 30.3714 7.8597 29.9944L8.77421 21.199L2.85667 14.6225C2.60306 14.3407 2.51887 13.945 2.63574 13.5843C2.75261 13.2236 3.05283 12.9525 3.42355 12.873L12.0726 11.0167L16.5116 3.36294C16.7016 3.03522 17.0518 2.8335 17.4307 2.8335ZM17.4307 6.01382L13.6748 12.4899C13.5244 12.7491 13.2716 12.9328 12.9786 12.9957L5.664 14.5655L10.6697 20.1286C10.8707 20.3521 10.9677 20.6502 10.9366 20.9492L10.1629 28.3908L17.0006 25.3644C17.2745 25.2432 17.5868 25.2432 17.8607 25.3644L24.6984 28.3908L23.9247 20.9492C23.8936 20.6502 23.9906 20.3521 24.1917 20.1286L29.1973 14.5655L21.8827 12.9957C21.5897 12.9328 21.3369 12.7491 21.1866 12.4899L17.4307 6.01382Z",
    fill: "#3677DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstrella34X34);
export default __webpack_public_path__ + "static/media/ESTRELLA_34X34.9ecb29adef83496c2737a40493525a67.svg";
export { ForwardRef as ReactComponent };